import { render, staticRenderFns } from "./bookRecommend.vue?vue&type=template&id=f2fed5e6&scoped=true&"
import script from "./bookRecommend.vue?vue&type=script&lang=js&"
export * from "./bookRecommend.vue?vue&type=script&lang=js&"
import style0 from "./bookRecommend.vue?vue&type=style&index=0&id=f2fed5e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fed5e6",
  null
  
)

export default component.exports